import { createEvent, restore, sample } from 'effector'
import { libraryGridPurchasedTvChannelsWidget } from '~/widgets/library/grid/purchased/tvChannels'

export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

sample({
  clock: libraryGridPurchasedTvChannelsWidget.$isGridPurchasedTvChannelsLoading,
  target: setContentLoading,
})
